'use strict';

module.exports = /*@ngInject*/ function() {
	var directive = {};

	directive.restrict = 'A';

	directive.scope = {
		categories: '=flxLandingVideoBackground',
		onSelect: '&'
	};

	directive.controller = 'flxLandingVideoBackgroundController';

	directive.controllerAs = 'flxLandingVideoBackgroundController';

	directive.templateUrl = 'flxLandingVideoBackground/flxLandingVideoBackground.tpl.html';

	return directive;
};
